import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/user-application'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getCompanyAppUsers ({ commit, dispatch }, payload) {
    let url = 'api/filterUserApp/' + payload.event.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetCompanyAppUsers', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({ commit, dispatch }, payload) {
    let url = 'api/user-application'
    let params = {
      'user_id': payload.event.item.user.id,
      'application_id': payload.event.item.application.id
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/user-application/' + payload.event.item.user.application.id + '/' + payload.event.item.user.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the userApplications endpoint
  onGet (state, payload) {
    let userApplications = payload.response.data.data
    payload.event.context.userApplications = userApplications
    payload.event.context.process()
  },
  onGetCompanyAppUsers (state, payload) {
    let userApplications = payload.response.data.data
    userApplications.forEach(item => {
      if (item.user.application[0] !== undefined) {
        let temp = Object.assign({}, item.user.application[0])
        item.user.application = {}
        item.user.application = Object.assign({}, temp)
      }
    })
    payload.event.context.companyUsersApp = userApplications
    // payload.event.context.process()
  },
  // Add the data from the new user to the users list
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Removes the data of the deleted user from the users list
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDelete()
    payload.event.context.refresh()
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    // payload.event.context.refresh()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userApplication.js